import React from "react";
import { isHtmlContent } from "utils/richTextHelpers";

const ProjectLocationContent = ({ content }) => {
  if (!content) return null;

  if (isHtmlContent(content)) {
    return (
      <div
        className="project-selection-card__address-content"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }

  return (
    <span className="project-selection-card__address-plain">{content}</span>
  );
};

export default ProjectLocationContent;
